<template>
  <div class="w-full h-full">
    <gmap-map :center="options.center" :zoom="options.zoom" class="h-full" ref="map" :options="options" mapTypeId="hybrid" @click="unselect" :key="reloadMap">
      <div v-if="$store.state.bigMap === false">
        <gmap-polygon  v-for="reserve in reserves" :options="reserve.region" :key="reserve.id" @click="unselect; storeReserve(reserve.id)" /> 
        <gmap-cluster :styles="clusterStyles" :maxZoom="17" :minimumClusterSize="1000" :zoomOnClick="true" @click="cuenta">          
          <gmap-marker v-for="tree in trees" :ref="tree.id" :position="tree.position" :icon="pin(tree)" :animation="tree.animation" :clickable="true" @click="markerClicked(tree)" :key="tree.id" />
        </gmap-cluster>  
      </div>
      <div v-if="$store.state.bigMap === true">  
        <gmap-info-window v-for="info in infos" :position="info.position" :key="info.lon" :options="infowindowoptions">
          <div class="containerInfo">
            <div class="nameClosed p-2" @click="open = info.reserve; storeReserve(info.reserve)" v-show="open !== info.reserve">
              <b>
                <center>
                  <div v-if="$i18n.locale === 'es'">{{reserve(info.reserve).name}}</div>
                  <div v-if="$i18n.locale === 'en'">{{reserve(info.reserve).name_us}}</div>
                  <div v-if="$i18n.locale === 'de'">{{reserve(info.reserve).name_de}}</div>
                </center>
              </b>
            </div>
            <div class="p-centered" v-if="open === info.reserve" @click="open = null;">
              <center class="nameOpen" v-if="$i18n.locale === 'es'">{{reserve(info.reserve).name}}</center>
              <center class="nameOpen" v-if="$i18n.locale === 'en'">{{reserve(info.reserve).name_us}}</center>
              <center class="nameOpen" v-if="$i18n.locale === 'de'">{{reserve(info.reserve).name_de}}</center>
              <iframe class="mt-3" width="240" height="135" :src="reserve(info.reserve).url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              <div class="pt-3 flex justify-center">
              <button class="btn btn-primary text-normal" @click="renderPoints()">{{ $t('verarboles') }}</button>
            </div>
          </div>
          </div>
        </gmap-info-window>
      </div>
    </gmap-map>
    <!-- <button class="btn btn-primary absolute pin-t" @click="showMapInfo">Map info</button> -->
   
    <map-cell v-if="selectedTree" :tree="selectedTree" v-on:clicked="showDetails(selectedTree)"/>
    <total-trees v-if="selector" :numberSeeds=totalSeeds :numberTrees=totalTrees v-on:clicked="showDetails(selectedTree)" > </total-trees> 
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import PlantTree from '@/components/modals/PlantTree'
import MapCell from '@/components/MapCell'
import TotalTrees from '@/components/TotalTrees'
import BuySeeds from '@/components/modals/BuySeeds'
import { isMobile } from '@/utils'
import InfoWindow from '../components/InfoWindow'

export default {
  name: 'Map',
  components: { 
   MapCell,
   TotalTrees,
   InfoWindow
  },
  mounted() {
    this.$ga.page('/Mapa');
  },
  data() {
    return {
      componentKey: false,
      calculate: null,
      open: false,
      infoClick: false,
      bigMap: true,
      selector:false,
      totalSeeds:0,
      totalTrees:0,
      selectedTree: null,
      firstTime: true,
      plantedPin: require('@/assets/images/pin_planted.svg'),
      unplantedPin: require('@/assets/images/pin_empty.svg'),
      plantedPinSelected: require('@/assets/images/pin_planted_selected.svg'),
      unplantedPinSelected: require('@/assets/images/pin_empty_selected.svg'),
      clusterStyles: [
        {
          url: require('@/assets/images/clustering40.svg'),
          height: 40,
          width: 40,
          textColor: '#41464A',
          textSize: 12
        },
        {
          url: require('@/assets/images/clustering50.svg'),
          height: 50,
          width: 50,
          textColor: '#41464A',
          textSize: 16
        },
        {
          url: require('@/assets/images/clustering60.svg'),
          height: 60,
          width: 60,
          textColor: '#41464A',
          textSize: 20
        },
        {
          url: require('@/assets/images/clustering70.svg'),
          height: 70,
          width: 70,
          textColor: 'white',
          textSize: 24
        },
        {
          url: require('@/assets/images/clustering80.svg'),
          height: 80,
          width: 80,
          textColor: '#41464A',
          textSize: 28
        }
      ],
      options: {
        zoom: 7,
        center: {
          lat: -2.117574,
          lng: -78.665511
        },
        minZoom: 7,
        scaleControl: true,
        mapTypeControl: false,
        zoomControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        //restriction: {
          //latLngBounds: {north: 1.5, south: -5, west: -81, east: -75.2},
        //}
      },
      infowindowoptions: {
        maxWidth: 270,
        minWidth: 270,
      }
    }
  },
  computed: {
    reloadMap () {
      return this.$store.state.reloadMap
    },
    infos() {
      //Get Infowindow Position
      var response = []
      for( let i = 0 ; i < 1; i++) {
        for(const key in this.$store.state.reserves.items) {
          if(this.$store.state.reserves.items[key].active) {
            let treesVar =  this.$store.state.reserves.items[key].trees
            for(var prop in treesVar) {
              treesVar[prop].reserve = key
              treesVar[prop].infoClick = false
              response.push(treesVar[prop])
              break
            }
          }
        }
      }
      return response
    },
    reserves () {
      var response = []
      const all = this.$store.state.reserves.items
      const reserveId = this.$route.params.reserveId
      for (const key in all) {
        if(this.$store.state.reservaAct === key) {
          const reserve = all[key];
          if (reserve.active) {
            if (reserveId) {
              if(reserveId == reserve.id) {
                response = [reserve]
                break
              }
            } else {
              response.push(reserve)
            }
          }
        }
      }
      if (this.firstTime && response.length > 0) {
        this.updateBound(response)
      }
      console.log('Ejecutado reservas')
      return response
    },
    trees() {
      var response = []
      this.reserves.forEach(reserve => {
        if(reserve.id === this.$store.state.reservaAct) {
          const seeds = reserve.seeds
          var ttseeds = 0
          console.log(reserve.seeds.length, 'esto')
          this.totalTrees = reserve.seeds.length
          for (const seedKey in reserve.seeds) {
            const planted = reserve.seeds[seedKey].planted
            if (planted) {
              ttseeds++
              reserve.trees[planted.treeId].isPlanted = true
              reserve.trees[planted.treeId].ownerId = planted.ownerId
            }else{
              this.reserva=reserve.id
            } 
          }
        }
        this.totalSeeds = ttseeds
        for (const key in reserve.trees) {
          var tree = reserve.trees[key]
          if (!this.$route.params.userId || tree.ownerId === this.$route.params.userId) {
            tree.reserveId = reserve.id
            response.push(tree)
          }
        }
      })
      console.log('Ejecutado arboles')
      return response
    }
  },
  methods: {
    bigMapBounds () {
      this.options.restriction.latLngBounds = null
      console.log('Lat Long Disabled')
    },
    renderPoints() {
      this.$store.commit('bigMap')
    },
    reserve(reserveId) {
      const data = this.$store.state.reserves.items[reserveId]
      return data
    },
    storeReserve(varReserva) {
      this.$store.commit('reservaActiva', varReserva) 
    },
    isMobile:() => {
      return isMobile() ? 'true' : 'false';
    },
    plant(tree) {
      this.$bvueUi.modal.show({
        component: PlantTree,
        width: 600,
        height: 500,
        data: {
          reserveId: tree.reserveId,
          treeId: tree.id,
          specie: tree.specie
        }
      })
    },
    async showMapInfo() {
      const map = await this.$refs.map.$mapPromise
      var m = 'Center:\n'
      m += 'lat: ' + map.center.lat() + '\n'
      m += 'lng: ' + map.center.lng() + '\n'
      m += 'Zoom: \n' + map.zoom
      alert(m)
    },
    pin(tree) {
      if (tree.isPlanted) {
        if (this.selectedTree && this.selectedTree.id == tree.id) {
          return this.plantedPinSelected
        }
        return this.plantedPin
      }
      if (this.selectedTree && this.selectedTree.id == tree.id) {
        return this.unplantedPinSelected
      }
      return this.unplantedPin
    },
    async updateBound(reserves) {
      if (!this.$refs.map) {
        return
      }
      const map = await this.$refs.map.$mapPromise
      var bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < reserves.length; i++) {
        const reserve = reserves[i];
        reserve.region.path.forEach(item => {
          bounds.extend(item);
        });
      };
      map.fitBounds(bounds);
    },
    unselect() {
      this.selectedTree = null
      this.selector = true
    },
    markerClicked(tree) {
      // this.options.center = tree.position
      this.selectedTree = tree
      this.selector = false
    },
    cuenta(tree) {
      // this.options.center = tree.position
       this.selector=true
    },
    async showDetails(tree) {
      const map = await this.$refs.map.$mapPromise
      var state = {
        center: {
          lat: map.center.lat(),
          lng: map.center.lng()
        },
        zoom: map.zoom
      }
      this.$store.dispatch('mapStates/setMapState', [state, this.$route.path])
      this.$router.push('/tree/'+tree.reserveId+'/'+tree.id)
    }
  },
  mounted() {
    // const storedState = this.$store.state.mapStates[this.$route.path]
    // if (storedState) {
    //   console.log('storedState: ', storedState)
    //   this.firstTime = false
    //   this.options.center = storedState.center
    //   this.options.zoom = storedState.zoom
    // }
  }
}
</script>

<style scoped lang="scss">
@import '@/style/_variables.scss';

.reserveCell {
  position:absolute;
  background:white;
  right:15px;
  top:15px;
  padding: 15px;
  min-width: 220px;
  @media screen and (max-width: $break-small) {
    padding: 8px;
  }
  .reserveName {
    color: $light-grey;
    text-transform: uppercase;
  }
}

.nameClosed {
  cursor: pointer;
  font-size: 0.8rem;
}

.nameOpen {
  cursor: pointer;
  font-size: 0.8rem;
}

.center-btn {
  margin: 0 auto;
}



</style>




// WEBPACK FOOTER //
// src/pages/Map.vue